import { A, Callout, ContactBlock, P, Section, Sub, Ul, card } from './LegalDoc'
import { CONTACT_EMAIL, OPERATOR_NAME } from './versions'

export default function EndUserTermsContent() {
  return (
    <div style={card}>
      <Section title="1. About these Terms">
        <P>
          These End User Terms govern your use of the Branon student apps, operated by{' '}
          <strong>{OPERATOR_NAME}</strong>. They apply to every student, whichever way your access
          was provided.
        </P>
        <Callout tone="info" title="Who provides your access">
          <Ul
            items={[
              <>
                <strong>Through your school:</strong> your school's agreement with us governs your
                account, billing, and termination.
              </>,
              <>
                <strong>Through your family's subscription:</strong> your parent's or guardian's
                subscription (under our Consumer Terms of Service, available in the Branon parent
                app) governs your account, billing, and termination.
              </>,
            ]}
          />
          <P>
            There are no payments or purchases inside the student apps — billing is always handled
            by your school or your parent.
          </P>
        </Callout>
      </Section>

      <Section title="2. Your account">
        <Ul
          items={[
            'Use only the account created for you (by your school, or by your parent).',
            'Keep your student ID and PIN confidential and do not share your account.',
            'If you forget your credentials: school-provided accounts are reset by your school; family accounts are reset by your parent from the Branon parent app.',
            'Tell your school or parent immediately if you think your account has been compromised.',
          ]}
        />
      </Section>

      <Section title="3. Acceptable use">
        <Sub title="You may">
          <Ul
            items={[
              'Use Branon to learn: explanations, practice, tests, and asking questions about what you are studying',
              'View your own progress and analytics',
            ]}
          />
        </Sub>
        <Sub title="You may not">
          <Ul
            items={[
              'Use Branon for cheating, or submit AI-generated content as your own original work',
              'Attempt to access other users’ accounts or data',
              'Reverse engineer the platform or use bots, scripts, or automated access',
              'Submit unlawful, offensive, or harmful content',
              'Copy, redistribute, or commercially exploit platform content',
            ]}
          />
        </Sub>
        <P>
          Serious or repeated violations may lead to suspension or termination of your account
          through your school or your parent's subscription.
        </P>
      </Section>

      <Section title="4. AI-generated content">
        <P>
          Branon's explanations, practice questions, chatbot answers, and exam simulations are
          generated by artificial intelligence. AI can make mistakes — always verify important
          answers against your textbook and your teachers. See the{' '}
          <A href="/disclaimer">Disclaimer</A> for details.
        </P>
      </Section>

      <Section title="5. Intellectual property">
        <P>
          Platform content, features, and branding belong to {OPERATOR_NAME}. You have a limited
          licence to use them for your own learning while your access is active. Questions and
          material you submit may be stored and used to operate and improve the platform, as
          described in the <A href="/privacy">Privacy Policy</A>.
        </P>
      </Section>

      <Section title="6. Availability and changes">
        <P>
          Branon is provided "as is" — we do not promise uninterrupted availability, and we may
          modify or update features at any time. Do not rely solely on Branon for time-sensitive
          school work.
        </P>
      </Section>

      <Section title="7. Governing law">
        <P>These Terms are governed by the laws of India.</P>
      </Section>

      <Section title="8. Contact">
        <ContactBlock email={CONTACT_EMAIL} operator={OPERATOR_NAME} />
      </Section>
    </div>
  )
}
